import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import '@teamhive/lottie-player';

@IonicPage()
@Component({
  selector: 'page-successful',
  templateUrl: 'successful.html',
})
export class SuccessfulPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SuccessfulPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/successful/successful.ts